import { render, staticRenderFns } from "./ppt-tool.vue?vue&type=template&id=7f5a1ab8&"
import script from "./ppt-tool.vue?vue&type=script&lang=js&"
export * from "./ppt-tool.vue?vue&type=script&lang=js&"
import style0 from "./ppt-tool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports